import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareCalendarClassicRoute: InvariantJiraRoute = {
	name: 'software-calendar-classic',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/:itemId?',
	query: ['date?'],
};
